import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

@Injectable()
export class SideMenuService {
  private _openedSubject = new BehaviorSubject<boolean>(false);
  readonly openedChanges = this._openedSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  get opened() {
    return this._openedSubject.getValue();
  }

  set opened(value) {
    this._openedSubject.next(!!value);
  }

  toggle() {
    this.opened = !this.opened;
  }

  open() {
    this.opened = true;
  }

  close() {
    this.opened = false;
  }
}
